<template>
    <div class="page">
        <div class="topBox">
            <!-- <div class="topTitle">ARTIST</div> -->
            <!-- <div class="topTitle2">签约艺术家</div> -->
            <!-- <div class="line"></div> -->
        </div>
        <pageBreadcrumb :option="nav_option" />
        <div class="search">
            <div class="wrap">
                <div class="searchBigBox">
                    <div class="searchBox">
                        <input type="text" v-model="keyword" class="searchInput" :placeholder="$t('请输入艺术家姓名搜索')" />
                        <div class="searchIcon" @click="queryBtn"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="listBox">
            <div class="wrap">
                <div class="listFlexBox">
                    <div class="itemBox" @click="goArtistDetail(item)" v-for="(item, index) in list" :key="index">
                        <div class="imgBox">
                            <div class="elImgBox">
                                <el-image class="img" :src="item.image" fit="cover"></el-image>
                            </div>
                            <img src="@/assets/img/productList/selectProductBg.png" class="selectProductBg" alt="" />
                        </div>
                        <div class="proTitle">{{ lang == 'en' ? item.enTitle : item.title }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap" v-if="list.length > 0">
            <el-pagination
                class="elpagination"
                background
                layout="prev, pager, next"
                :total="count"
                :current-page="page"
                :page-size="pageNum"
                @current-change="changePage"
            >
            </el-pagination>
        </div>
        <el-empty :description="$t('暂无内容...')" v-if="list.length == 0"></el-empty>
        <div class="fill100"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import pageBreadcrumb from '@/components/page/page-breadcrumb.vue'

export default {
    name: 'artistList',
    components: {
        pageBreadcrumb,
    },
    data() {
        return {
            nav_option: [],
            count: 0,
            page: 1,
            pageNum: 10,
            keyword: '',
            list: [],
        }
    },
    computed: {
        ...mapState([]),
    },
    watch: {
        '$route.query.keyword'() {
            location.reload()
        },
    },
    created() {
        this.nav_option = [
            { title: this.$t('首页'), path: '/' },
            { title: this.$t('签约艺术家'), path: '' },
        ]
        if (this.$route.query.keyword != undefined) {
            this.keyword = this.$route.query.keyword
        }
        this.getList()
    },
    methods: {
        queryBtn() {
            this.page = 1
            this.getList()
        },
        async getList() {
            let obj = {
                page: this.page,
                pageNum: this.pageNum,
            }
            if (this.keyword) {
                obj.keyword = this.keyword
            }
            // this.$load.open()
            let res = await this.artistListsAjax(obj)
            // this.$load.close()
            if (res && res.code == 200) {
                this.list = res.data.list
                this.count = res.data.count
            }
        },
        artistListsAjax(obj = {}) {
            return new Promise(async (resolve, reject) => {
                this.$api({
                    url: '/service.php',
                    method: 'get',
                    data: {
                        action: 'artist_lists',
                        ...obj,
                    },
                }).then((res) => {
                    if (res.code == 200) {
                        resolve(res)
                    } else if (res.code == 500) {
                        alertErr(res.msg)
                        resolve(false)
                    } else {
                        alertErr('获取失败')
                        resolve(false)
                    }
                })
            })
        },
        changePage(index) {
            this.page = index
            this.getList()
        },
        goArtistDetail(item) {
            this.$router.push({
                path: '/artistDetail',
                query: {
                    id: item.id,
                },
            })
        },
    },
}
</script>

<style scoped lang="less">
.topBox {
    width: 100%;
    height: 400px;
    background: url('../../assets/img/artist/topBg.png') no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
    margin-bottom: 50px;

    .topTitle {
        width: 100%;
        text-align: center;
        margin-top: 100px;
        font-size: 55px;
        line-height: 55px;
        color: #ffffff;
        font-family: 'myTextStyle';
        // margin-bottom: 23px;
        margin-bottom: 110px;
    }

    .topTitle2 {
        width: 100%;
        text-align: center;
        font-weight: bold;
        font-size: 55px;
        line-height: 55px;
        color: #ffffff;
        margin-bottom: 110px;
    }

    .line {
        width: 155px;
        height: 3px;
        background: #ffffff;
        margin: 0 auto;
    }
}

.search {
    margin-top: -30px;

    .searchBigBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        overflow: hidden;

        .searchBox {
            width: 380px;
            height: 40px;
            background: #eeeeee;
            border-radius: 100px 100px 100px 100px;
            border: 1px solid rgba(112, 112, 112, 0.6);
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 16px;

            .searchInput {
                width: 300px;
                font-weight: 500;
                font-size: 16px;
                color: #555555;
                line-height: 40px;
                background: transparent;
            }

            .searchIcon {
                width: 18px;
                height: 18px;
                background: url('../../assets/img/artist/query.png') no-repeat;
                background-size: 100% 100%;
                cursor: pointer;
            }
        }
    }
}

.wrap {
    width: @width;
    overflow: hidden;
    margin: 0 auto;
}

.listBox {
    width: 100%;
    margin-top: 100px;

    .listFlexBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;

        .itemBox {
            width: calc((100% - 63px * 4) / 5);
            margin-right: 63px;
            margin-bottom: 48px;
            cursor: pointer;

            .proTitle {
                width: 100%;
                font-size: 20px;
                color: #000000;
                line-height: 30px;
                max-height: 60px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                text-align: center;
            }

            &:nth-child(5n) {
                margin-right: 0;
            }

            &:nth-child(-n + 5) {
                margin-top: 0;
            }

            .imgBox {
                width: 100%;
                position: relative;
                margin-bottom: 15px;

                .elImgBox {
                    width: 100%;
                    height: 0;
                    padding-bottom: 66%;
                    position: relative;

                    .img {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                        border-radius: 10px;
                    }
                }

                .selectProductBg {
                    display: none;
                    width: 100%;
                    height: 240px;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
            }

            &:hover {
                // .selectProductBg {
                //     display: block;
                // }

                .proTitle {
                    color: #ff4d00;
                }
            }
        }
    }
}

.elpagination {
    text-align: center;
}

.fill100 {
    width: 100%;
    height: 100px;
}
</style>
<style scoped lang="less" src="@/assets/h5css/mobile/artistList.less"></style>
